import React, {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {FormattedMessage} from "react-intl";
import VideoConferenceLink from "../../../../../timeline/components/VideoConferenceLink";
import {getVideoConferenceLink} from "../../../../../../utils/TimelineUtils";
import {OTLink} from "../../../../../../components/tag/OTLink";

const TimelineFrameContentVideoConference = () => {
    const {data, past} = useContext(TimelineFrameDataContext);

    if(!past) {
        return (
            <div>
                <div>
                    <FormattedMessage id={"video.conference.microphone.permission.instructions"} />
                </div>
                <div className={"card-link link__video-conference"}>
                    <FormattedMessage id={"go.to.video.conference"}>
                        {txt =>
                            <OTLink isExternal onClick={getVideoConferenceLink} target={'_blank'}>
                                {txt}
                            </OTLink>
                        }
                    </FormattedMessage>
                </div>
            </div>
        )
    }
    return null;
}

export default TimelineFrameContentVideoConference;